import initialState from '../store/initial-state'
import { ASSET_RIGHTS_STATE_UPDATED } from '../constants/rights-constants'
import {
  SEARCHING,
  SEARCH_FAILURE,
  SEARCH_SUCCESS,
  SEARCH_EMPTY,
  SEARCH_ACTIVEVIEW,
  SEARCH_SET_SELECT,
  SEARCH_UNSET_SELECT,
  SEARCH_EDIT,
  SEARCH_EDIT_SELECT,
  SEARCH_EDIT_UNSET_SELECT,
  SEARCH_EDIT_SUCCESS,
  SEARCH_EDIT_FAILURE,
  SEARCH_EXPAND_SELECT,
  SEARCH_EXPAND_UNSET_SELECT,
  SEARCH_SHARE_SELECT,
  SEARCH_SHARE_UNSET_SELECT,
  SEARCH_DELETE,
  SEARCH_DELETE_SUCCESS,
  SEARCH_DELETE_FAILURE,
  SEARCH_MOVE,
  SEARCH_MOVE_SUCCESS,
  SEARCH_MOVE_FAILURE,
  ASSET_SEARCH_CHECK_SELECT,
  ASSET_SEARCH_UNCHECK_SELECT,
  MULTIPLE_SEARCH_OPTIONS_ACTIVATE,
  MULTIPLE_SEARCH_OPTIONS_DEACTIVATE,
  MULTIPLE_SEARCH_OPTIONS_DONE,
  GO_TO_PAGE,
  IS_SEARCH_ADVANCED,
  SEARCH_ADVANCED_EMPTY,
  ASSETS_SEARCH_MULTI_DELETE,
  ASSETS_SEARCH_MULTI_DELETE_SUCCESS,
  ASSETS_SEARCH_MULTI_DELETE_FAILURE,
  ASSETS_SEARCH_MULTI_MOVE,
  ASSETS_SEARCH_MULTI_MOVE_SUCCESS,
  ASSETS_SEARCH_MULTI_MOVE_FAILURE,
  CLEAN_DATA_BACK_SEARCH,
  SCROLL_SEARCH,
  CANCEL_SEARCH,
  GET_SUGGEST,
  GET_SUGGEST_SUCCESS,
  GET_SUGGEST_FAILURE
} from '../constants/search-types'
import { verifySpecialCharsInSearch } from '../utils'

export default (state = initialState.searcher, action) => {
  switch (action.type) {
    case SEARCHING:
      return {
        ...state,
        isFetching: action.payload.isFetching,
        // limit: action.payload.limit,
        // data: [],
        data: action.payload.data,
        isLoadingScroll: action.payload.isLoadingScroll,
        showScrolling:  false,
        error: null
      }

    case SEARCH_SUCCESS:
      const { searchText } = action.payload;
      const verify = (verifySpecialCharsInSearch(searchText))
        ? decodeURIComponent(searchText)
        : searchText

      const pageScroll = action.payload.page
      return {
        ...state,
        isFetching: false,
        isAdvancedSearching: false,
        searchText: verify,
        searchType: action.payload.searchType,
        data: pageScroll !== 1 ? [...state.data, ...action.payload.data] : action.payload.data,
        orderBy: action.payload.orderBy,
        headers: action.payload.headers,
        error: null,
        showScrolling:  false,
        isLoadingScroll: false,
        pageScrolling: pageScroll

      }

    case SEARCH_FAILURE:
      return {
        ...state,
        isFetching: false,
        searchText: action.payload.searchText,
        searchType: action.payload.searchType,
        page: 1,
        limit: 40,
        data: [],
        headers: [],
        error: action.payload.error,
        showScrolling:  false,
        isAdvancedSearching: false
      }

    case SEARCH_EMPTY:
      return {
        ...state,
        isFetching: false,
        searchText: '',
        searchType: 'all',
        data: [],
        headers: [],
      }

    case SEARCH_ACTIVEVIEW:
      return {
        ...state,
        activeView: action.payload.activeView
      }

    case SEARCH_SET_SELECT:
      const maxItems = action.payload.from === 'vertical'
        ? action.payload.verticalCount
        : action.payload.horizontalCount
      let exist = false
      let count = 0

      return {
        ...state,
        data: [...state.data.map((r, k) => {
          let i = k + 1
          if (count >= maxItems) {
            count = 1
            exist = false
          } else {
            count++
          }
          if (!exist) exist = `${action.payload.from}-${i}` === action.payload.indice
          return {
            ...r,
            drawMiddleView: (exist && maxItems === count) || (exist && i === state.data.length),
            isSelected: r._id === action.payload.data._id,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null
          }
        })]
      }

    case SEARCH_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            drawMiddleView: false,
            isSelected: false,
            isEditSelected: false,
            indice: null,
            from: null
          }
        })]
      }

    case SEARCH_EDIT:
      return {
        ...state,
        isUpdating: true,
        headers: null,
        error: null
      }

    case SEARCH_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null,
            name: r._id === action.payload.data._id
              ? action.payload.data.name
              : r.name,
            metadata: {
              ...r.metadata,
              descriptiveTags: r._id === action.payload.data._id
                ? action.payload.data.metadata.descriptiveTags
                : r.metadata && r.metadata.descriptiveTags ? r.metadata.descriptiveTags : [],
              createdDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.createDate
                : r.metadata && r.metadata.createDate ? r.metadata.createDate : null,
              dueDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.dueDate
                : r.metadata && r.metadata.dueDate ? r.metadata.dueDate : null,
            }
          }
        })]
      }

    case ASSET_RIGHTS_STATE_UPDATED: {
      const hasAsset = state.data.some(r => r._id === action.payload.assetId)
      if (!hasAsset) return state
      return {
        ...state,
        data: state.data.map(r =>
          r._id === action.payload.assetId
            ? {
                ...r,
                rightsState: action.payload.rightsState,
                metadata: {
                  ...r.metadata,
                  rightsStatus: action.payload.rightsStatus,
                  dueDate: action.payload.dueDate,
                  createdDate: action.payload.createdDate,
                  // El contrato y la hora de asignación también: la bitácora se
                  // refresca con ellos cuando lo único que cambió fue el contrato.
                  licenseFile: action.payload.licenseFile,
                  rightsAssignedAt: action.payload.rightsAssignedAt
                }
              }
            : r
        )
      }
    }

    case SEARCH_EDIT_FAILURE:
      return {
        ...state,
        isUpdating: false,
        headers: null,
        error: action.payload
      }

    case SEARCH_EDIT_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: r._id === action.payload.data._id,
          }
        })],
        editAssetTab: action.payload.editAssetTab
      }

    case SEARCH_EDIT_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: false,
          }
        })]
      }

    case SEARCH_EXPAND_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case SEARCH_EXPAND_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: false,
          }
        })]
      }

    case SEARCH_SHARE_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case SEARCH_SHARE_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: false,
          }
        })]
      }

    case SEARCH_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case SEARCH_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case SEARCH_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }

    case SEARCH_MOVE:
      return {
        ...state,
        isMoving: true,
        isInFolderAction: true,
        headers: null,
        error: null
      }

    case SEARCH_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isEditSelected: false,
            isMoved: r._id === action.payload.data._id,
          }
        })]
      }

    case SEARCH_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }

    case ASSET_SEARCH_CHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = true : r.isCheckMultiple
          }
        })]
      }

    case ASSET_SEARCH_UNCHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = false : r.isCheckMultiple
          }
        })]
      }

    case MULTIPLE_SEARCH_OPTIONS_ACTIVATE:
      return {
        ...state,
        activateMultiOptions: true
      }
    case MULTIPLE_SEARCH_OPTIONS_DEACTIVATE:
      return {
        ...state,
        activateMultiOptions: false
      }

    case MULTIPLE_SEARCH_OPTIONS_DONE:
      return {
        ...state,
        activateMultiOptions: false,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: false
          }
        })]
      }

    case GO_TO_PAGE:
      return {
        ...state,
        page: action.payload.page
      }

    case IS_SEARCH_ADVANCED:
      return {
        ...state,
        isAdvancedSearchActive: action.payload.isAdvancedSearchActive, // INDICA SI EL BUSCADOR AVANZADO ESTÁ EN BUSQUEDA ACTIVA, PARA PAGINACIÓN
        isAdvancedSearching: action.payload.isAdvancedSearching, // INDICA SI ESTA REALIZANDO LA PETICION A API
        advancedSearchValues: action.payload.advancedSearchValues // VALORES DE LA ÚLTIMA BÚSQUEDA
      }

    case SEARCH_ADVANCED_EMPTY:
      return {
        ...state,
        isAdvancedSearching: false,
        advancedSearchValues: ''
      }
    case ASSETS_SEARCH_MULTI_DELETE:
      return {
        ...state,
        isFetching: true
      }
  
    case ASSETS_SEARCH_MULTI_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => !action.payload.ids.includes(r._id))],
        error: null
      }

    case ASSETS_SEARCH_MULTI_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }
    case ASSETS_SEARCH_MULTI_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSETS_SEARCH_MULTI_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: action.payload.ids.includes(r._id),
          }
        })]
      }

    case ASSETS_SEARCH_MULTI_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }
    case CLEAN_DATA_BACK_SEARCH:
      return {
        ...state,
        data: [],
        showScrolling: false,
        pageScrolling: 1
      }
    case SCROLL_SEARCH:
      return {
        ...state,
        showScrolling: action.payload.showScrolling,
        pageScrolling: action.payload.pageScrolling,
      }
    case CANCEL_SEARCH:
      return { ...state, isFetching: false, isAdvancedSearching: false }
    case GET_SUGGEST:
      return { ...state, loadingSuggest: true }
    case GET_SUGGEST_SUCCESS:
      return { ...state, loadingSuggest: false, suggestions: action.payload }
    case GET_SUGGEST_FAILURE:
      return { ...state, loadingSuggest: false, suggestions: [] }
    default: return { ...state }
  }
}
